import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { valueRender } from '@repo/toolkit/conditional-render'
import { DateFormatter } from '@repo/toolkit/date'
import { NumberFormatter } from '@repo/toolkit/number'
import { useNavigator } from '@repo/toolkit/use-navigator'
import Badge from '@repo/ui/badge'
import Button from '@repo/ui/button'
import Checkbox from '@repo/ui/checkbox'
import { BuildingThreeIcon, ClipboardIcon } from '@repo/ui/icons'
import InnerBox from '@repo/ui/inner-box'
import Typography from '@repo/ui/typography'
import { useFormContext } from 'react-hook-form'

import { Paths } from '../../../lib/constants/path'
import { travelExpensesStatusEnumMapping } from '../../../lib/types/enums/affected-staff/affected-staff-status.enum'
import { AffectedStaff } from '../../../lib/types/models/affectedStaff/affected-staff'
import { AffectedStaffInput } from '../../../lib/types/models/affectedStaff/affected-staff-input'
import LabelWithText from '../ols/label-with-text'

type Props = {
  affectedStaff: AffectedStaff
}

const AffectedStaffTravelExpenses = ({ affectedStaff }: Props) => {
  const { navigate } = useNavigator()
  const form = useFormContext<AffectedStaffInput>()

  const hasHotelBooking = form.watch('expenseIncludeHotelBooking')

  const travelExpensesTotal = affectedStaff.travelExpenses.reduce((sum, expense) => {
    return sum + (expense.validatedAmount || 0)
  }, 0)

  const travelExpensesText = NumberFormatter.formatCurrency(
    travelExpensesTotal,
    affectedStaff.travelExpensesCurrency
  )

  return (
    <InnerBox className="rounded-lg">
      <div className="flex justify-between items-center w-full">
        <Typography variant="text" color={tailwindColors.primary.DEFAULT}>
          Note de frais
        </Typography>
        <Button
          type="button"
          variant="secondary"
          label="Voir la note de frais"
          icon={ClipboardIcon}
          onClick={() =>
            navigate(
              Paths.AFFECTED_STAFF_EXPENSE_REPORT_DETAILS_PAGE.replace(
                ':id',
                affectedStaff.id.toString()
              )
            )
          }
        />
      </div>
      <div className="h-3" />
      <div className="grid  grid-cols-3 items-center ">
        <LabelWithText
          label="Date de reception"
          data={
            <Badge
              text={valueRender(affectedStaff.travelExpensesSentAt, (d) =>
                DateFormatter.DDMMYYYY(d)
              )}
            />
          }
        />
        <Badge
          size="medium"
          className="place-self-center"
          color={tailwindColors.white.active}
          textColor={tailwindColors.primary.DEFAULT}
          text={`Montant : ${travelExpensesText}`}
        />

        <LabelWithText
          className="place-self-end"
          label="Statut"
          data={
            <Badge
              variant={travelExpensesStatusEnumMapping[affectedStaff.travelExpensesStatus].variant}
              text={travelExpensesStatusEnumMapping[affectedStaff.travelExpensesStatus].label}
            />
          }
        />
      </div>
      <div className="h-3" />
      <InnerBox className="drop-shadow-2xl shadow w-fit py-2 px-3">
        <div className="flex gap-2 items-center">
          <Checkbox
            checked={hasHotelBooking}
            onChange={(checked) => form.setValue('expenseIncludeHotelBooking', checked)}
          />
          <div className="flex items-center gap-1">
            <BuildingThreeIcon color={tailwindColors.black.DEFAULT} />
            <Typography variant="tag" color={tailwindColors.black.DEFAULT}>
              OK hôtel
            </Typography>
          </div>
        </div>
      </InnerBox>
    </InnerBox>
  )
}

export default AffectedStaffTravelExpenses
